var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessCircled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 175,
    viewBox: "0 0 174 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1667 91.479L79.0417 115.354L118.833 67.604",
    stroke: "url(#paint0_linear_32187_36592)",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87 167.083C130.953 167.083 166.583 131.452 166.583 87.4998C166.583 43.5472 130.953 7.9165 87 7.9165C43.0473 7.9165 7.41666 43.5472 7.41666 87.4998C7.41666 131.452 43.0473 167.083 87 167.083Z",
    stroke: "url(#paint1_linear_32187_36592)",
    strokeWidth: 14
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32187_36592",
    x1: 57.8366,
    y1: 69.7315,
    x2: 184.627,
    y2: 130.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D8A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0185FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32187_36592",
    x1: 14.0914,
    y1: 15.0081,
    x2: 358.99,
    y2: 138.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D8A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0185FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircled);
export default __webpack_public_path__ + "static/media/success-circled.bc22c18f.svg";
export { ForwardRef as ReactComponent };